import { Badge } from '../Badge/Badge';
import { Icon } from '../Icon/Icon';
import styles from './NavigationItem.module.scss';

export interface NavigationItemProps {
  iconName: string;
  label: string;
  isActive?: boolean;
  disabled?: boolean;
  badge?: number;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
  'data-testid': string;
}

export const NavigationItem = ({
  iconName,
  label,
  isActive = false,
  disabled = false,
  badge,
  onClick,
  'data-testid': testId,
  href,
  target,
  rel,
}: NavigationItemProps) => {
  const classNameStr = [
    styles['item'],
    isActive ? styles['item--active'] : '',
    disabled ? styles['item--disabled'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <span className={styles['item-content']}>
      <span className={styles['icon-wrapper']} aria-hidden="true">
        <Icon name={iconName} size={24} />
        {badge !== undefined && badge > 0 && (
          <Badge
            count={badge}
            size="sm"
            className={styles['badge-position']}
            data-testid="nav-badge"
          />
        )}
      </span>
      <span className={styles['item-label']}>{label}</span>
    </span>
  );

  if (href && !disabled) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        className={classNameStr}
        onClick={onClick}
        aria-current={isActive ? 'page' : undefined}
        aria-label={
          badge !== undefined && badge > 0 ? `${label} (${badge})` : undefined
        }
        data-testid={testId}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={classNameStr}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      aria-current={isActive ? 'page' : undefined}
      aria-pressed={isActive || undefined}
      aria-label={
        badge !== undefined && badge > 0 ? `${label} (${badge})` : undefined
      }
      data-testid={testId}
    >
      {content}
    </button>
  );
};
